"use client"

import { useState } from "react"

import { cn } from "@shared/ui/lib/utils"

import type { StaticAsset } from "../lib/resolve-asset-src"
import { resolveAssetSrc } from "../lib/resolve-asset-src"

type WalletIconProps = {
  logo: StaticAsset
  name: string
  className?: string
}

export function WalletIcon({ logo, name, className }: WalletIconProps) {
  const [failed, setFailed] = useState(false)
  const src = resolveAssetSrc(logo)
  const initials = name
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("")

  if (failed || !src) {
    return (
      <span
        className={cn(
          "flex size-full items-center justify-center rounded-md bg-muted text-[10px] font-semibold text-muted-foreground",
          className,
        )}
        aria-hidden="true"
        title={name}
      >
        {initials || "?"}
      </span>
    )
  }

  return (
    <img
      src={src}
      alt=""
      className={className}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  )
}
